// photonenergy.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Energi Foton";
const DESCRIPTION =
  "Kalkulator energi foton akurat: Hitung energi foton (dalam joule atau elektron volt) menggunakan frekuensi gelombang atau panjang gelombang dan konstanta Planck. Alat penting untuk mahasiswa fisika, kimia, dan teknik!";
const KEYWORDS = "energi foton, menghitung energi foton, kalkulator foton";
const OG_URL = "https://do-calculate.com/calculator/id/photonenergy";
function PhotonEnergyCalculator() {
  const [frequency, setFrequency] = useState("");
  const [photonEnergy, setPhotonEnergy] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!frequency) {
      setError("Harap masukkan frekuensi foton dengan benar");
      setPhotonEnergy("");
      return;
    }
    const frequencyValue = parseFloat(frequency);
    if (isNaN(frequencyValue) || frequencyValue <= 0) {
      setError("Harap masukkan nilai yang valid dan positif untuk frekuensi foton");
      setPhotonEnergy("");
      return;
    }
    const planckConstant = 6.626e-34;
    const photonEnergyValue = (planckConstant * frequencyValue).toPrecision(2);
    setPhotonEnergy(photonEnergyValue);
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Cara Menghitung Energi Foton</h2>
                <p>
                  Energi foton dapat dihitung berdasarkan frekuensi foton menggunakan rumus berikut:
                </p>
                <p>Energi Foton (E) = Konstanta Planck (h) × Frekuensi Foton (ν)</p>
                <p>Harap masukkan frekuensi foton untuk menghitung energi foton.</p>
                <hr />
              </div>
            </div>
                            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Frekuensi Foton (Hertz)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="2.5e14"
                        value={frequency}
                        onChange={(e) => setFrequency(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Energi Foton
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {photonEnergy !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            Energi Foton (joule): {photonEnergy} Joule
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default PhotonEnergyCalculator;